import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex items-center gap-2 bg-white rounded-full"
}
const _hoisted_2 = ["d"]

import { ref, computed } from 'vue'
import { mdiHistory } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isActive: { type: Boolean },
    size: { default: 'normal' },
    loading: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;





const isClicked = ref(false)
const isHovering = ref(false)

function handleClick() {
  isClicked.value = !isClicked.value
  emit('click')
}

const skeletonClass = computed(() => {
  return props.size === 'small' ? 'w-9 h-9' : 'w-12 h-12'
})

const containerClass = computed(() => {
  const sizeClasses = props.size === 'small' ? 'w-9 h-9' : 'w-12 h-12'
  const backgroundClass = isHovering.value ? 'bg-[#D5EDF2]' : 'bg-transparent'

  return [
    'flex items-center justify-center rounded-full border-2 border-primary30 transition-all duration-300 cursor-pointer',
    sizeClasses,
    backgroundClass
  ]
})

const svgClass = computed(() => {
  return props.size === 'small' ? 'w-6 h-6' : 'w-8 h-8'
})

return (_ctx: any,_cache: any) => {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([skeletonClass.value, "bg-slate-200 animate-pulse rounded-full border-2 border-white shadow-sm"])
      }, null, 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: handleClick,
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHovering.value = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHovering.value = false)),
          class: _normalizeClass(containerClass.value)
        }, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: _normalizeClass(svgClass.value),
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              d: _unref(mdiHistory),
              fill: "#2F7F91"
            }, null, 8, _hoisted_2)
          ], 2))
        ], 34)
      ]))
}
}

})